class validatorButtonDirective{
  constructor(){
    'ngInject';
    this.restrict = 'A';
  }

  /**
   *
   * @param scope
   * @param element
   * @param attribute
   */
  link( scope, element, attribute ){
    setTimeout(() => {
    let form = $(`form[name="${attribute.validatorButton}"]`);
    element.on('click', (e) => {
      let inputs = form.find('input.form-control, select.form-control');
      angular.forEach(inputs, ( input ) => {
        $(input).trigger('focus').trigger('blur');
      } );
      if( form.find('.has-error').length ) {
        e.preventDefault();
        const errorInputs = form.find('.form-group.has-error input');
        errorInputs[0] && errorInputs[0].focus();
        return false;
      }

    });
    });

  }
  static create(){
    return new validatorButtonDirective();
  }
}

export { validatorButtonDirective };


/** WEBPACK FOOTER **
 ** ./frontend/components/active/validator/validator-button.directive.js
 **/